import { combineReducers } from 'redux';

// note - the reducer variable names are important and shouldn't change,
// because components map their props to them
import paramsReducers from 'app/reducers/paramsReducers';
import userReducer from 'shared/reducers/userReducer';
import photoSwipeReducer from 'app/reducers/photoSwipeReducer';
import portalReducer from 'app/reducers/portalReducer';
import viewportReducer from 'app/reducers/viewportReducer';
import messagesReducer from 'shared/reducers/messagesReducer';
import knockOutReducer from 'app/reducers/knockout';
import gridStateReducer from 'app/reducers/gridState';

export default combineReducers({
  params: paramsReducers,
  userReducer,
  photoSwipeReducer,
  portalReducer,
  viewportReducer,
  messagesReducer,
  knockOutReducer,
  gridStateReducer
});
